import React from 'react';
import { connect } from 'react-redux';

import CustomHead from '@components/customHead/CustomHead.tsx';
import ListAbsoluteMain from '@components/listAbsoluteMain/ListAbsoluteMain.tsx';
import { s } from '@functions/seo.ts';
import { StoreT } from '@global/types.ts';

import checkPage from './methods/checkPage.ts';
import setPagesKey from './methods/setPagesKey.ts';

import BlogI from './types.ts';

import renderPage from './renders/renderPage.tsx';
import meta from './static/meta.ts';
import sections from './static/sections.ts';

class Blog extends React.Component<BlogI['props'], BlogI['state']> implements BlogI {
    parent: BlogI['parent'];

    constructor(props: BlogI['props']) {
        super(props);

        let pageId;
        let pageName;

        if (s() && this.props.seoData?.blogId === 'main') {
            pageId = 'main';
            pageName = 'main';
        }

        if (s() && this.props.seoData?.blogId !== 'main') {
            pageId = this.props.seoData?.blogId;
            pageName = 'inner';
        }

        this.state = {
            pageId,
            pageName: pageName || 'main',
        };

        this.parent = React.createRef();
    }

    meta = meta;

    sections = sections;

    checkPage = checkPage;
    setPagesKey = setPagesKey;

    renderPage = renderPage;

    componentDidMount() {
        this.checkPage();
    }

    componentDidUpdate() {
        this.checkPage();
    }

    render() {
        const { pageName, pageId, updatedPagesKey } = this.state;

        return (
            <>
                <CustomHead title={this.meta.title} description={this.meta.description} />

                <div className="public__section _full">
                    <ListAbsoluteMain
                        className="public__innerPages"
                        items={pageId ? [{ key: pageId, name: pageName }] : []}
                        renderItem={this.renderPage.bind(this)}
                        classNameItem="public__innerPage"
                        prop="key"
                        styles={[]}
                        isNotParamsItem={true}
                        currentItemKey={pageName}
                        allItems={['main', 'inner']}
                        keyRender={updatedPagesKey}
                    />
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        levels: state.levels,
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(Blog);
